import React from 'react';

interface MarketingOptInProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Optional consent for news / event emails.
 * Must stay unticked by default (Spam Act: consent has to be an active choice).
 */
export const MarketingOptIn: React.FC<MarketingOptInProps> = ({ checked, onChange }) => (
  <div className="flex items-start">
    <input
      id="marketing_opt_in"
      name="marketing_opt_in"
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="h-4 w-4 mt-0.5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
    />
    <label htmlFor="marketing_opt_in" className="ml-2 block text-sm text-gray-700">
      Send me news about SDG events and updates <span className="text-gray-400">(optional)</span>
      <span className="block text-xs text-gray-500 mt-0.5">
        You can unsubscribe at any time from your profile or from any email.
      </span>
    </label>
  </div>
);
